import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { userByRole } from './userByRole';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { enumItems } from './enumItems';
import { service } from './service';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";

export const serviceProviderEventStaffSingle: SchemaWithClient<any> = {
  name: 'Event Staff',
  pluralName: 'Event Staff',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    event_staff: {
      name: 'Event Staff',
      fieldRenderer: SelectField.tableAdapter(userByRole('9')),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(userByRole('9')),
      switchboard: true,
      url: userByRole('9').client.getAllPath,
      tempSchema: userByRole('9'),
    },
    service: {
      name: 'Service',
      fieldRenderer: SelectField.tableAdapter(service),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(service),
      url: service.client.getAllPath,
      tempSchema: service,
      switchboard: true,
      accordingTo: 'service_provider',
    },
    cost: {
      name: 'Cost',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'float',
    },
    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
      switchboard: true,
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/single-service-provider-event-staff'),
};
